import axios from "axios";

const baseURL = `${process.env.EMPLEO_SERVICES_API_URL}`;
const urlAportantes = `${process.env.URL_SUBSIDIO_APORTANTE}`;
const keyUrlAportantes = `${process.env.URL_SUBSIDIO_APORTANTE_KEY}`;

// Metodo para traer info de los aportantes con subsidio fosfec, ms-sap-erp-cesantes
const dataMPCAportante = async (token , documentType, documentNumber) => {
    const headers = {
        '_TIPO_DOCTO': documentType,
        'I_NRO_DOCTO': documentNumber,
        'Apikey': keyUrlAportantes,
        'Authorization': token,
      };
    const data = await axios.get(urlAportantes, { headers });
    return data;
}

//Metodo para trear info de las personas que han recibido subsidio en los ultimos 3 años, MS-common.webApi
const getInformation = async (documentType, documentNumber) => {
    const fechaActual = new Date();
    const fechaHaceTresAnios = new Date(fechaActual.getFullYear() - 3, fechaActual.getMonth(), fechaActual.getDate());
    const anio = fechaHaceTresAnios.getFullYear();
    const mes = ("0" + (fechaHaceTresAnios.getMonth() + 1)).slice(-2); // Agrega un cero inicial si el mes es menor a 10
    
    const data = await axios.get(
        `${baseURL}comfama/common/api/v1/subsidios/afiliados/${documentNumber}/${documentType}/${anio}${mes}/Titular/`
    );
    return data;
};

export { getInformation, dataMPCAportante };